<script setup>
import { defineProps, defineEmits} from "vue";
import LinhaDeContasAPagarResumo from "./LinhaDeContasAPagarResumo.vue";
import LinhaDeContasAPagarDetalhes from "./LinhaDeContasAPagarDetalhes.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
]);

const emits = defineEmits([
    "update:alteraContaAPagar",
    "update:alteraPagamento",
]);

//==================================================================//
//================== Altera Conta a Pagar ==========================//
//==================================================================//

const alteraContaAPagar = (update = {})=>{

    update.id = props?.contaAPagar?.id;
    emits('update:alteraContaAPagar',update);

};

//==================================================================//
//==================== Altera Pagamento ============================//
//==================================================================//

const alteraPagamento = (updatePagamento = {})=>{

    let update = {
        contaAPagar:{
            id: props?.contaAPagar?.id
        },
        pagamento: updatePagamento
    }

    emits('update:alteraPagamento',update);

};

</script>

<template>

    <div class="c-table__row-group">

        <LinhaDeContasAPagarResumo
            :controlesDesativados="props?.controlesDesativados"
            :dado="props?.dado"
            :contaAPagar="props?.contaAPagar"
            @update:alteraContaAPagar="alteraContaAPagar"
        ></LinhaDeContasAPagarResumo>

        <LinhaDeContasAPagarDetalhes
            :controlesDesativados="props?.controlesDesativados"
            :dado="props?.dado"
            :contaAPagar="props?.contaAPagar"
            @update:alteraPagamento="alteraPagamento"
        ></LinhaDeContasAPagarDetalhes>

    </div>

</template>

<style scoped>

.c-table__row-group{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
}

</style>
